// ExtrasScreen.jsx

import React, { useEffect } from "react";

import ReportChartBarsExtras from "../components/ReportChartBarsExtras";

const ExtrasScreen = ({ data, js, title, description }) => {
    useEffect(() => {
        // if (data[""]) {
        //     //
        // }
    }, [data]);
    console.log({ js });
    const filters = ((js ?? {}).filters ?? {}).Extras || []; // TODO: if we undo the filter other extras, we have to remove this

    return (
        <>
            <ReportChartBarsExtras
                data={data}
                title={title}
                description={description}
                filters={filters}
                entriesLimit={5}
                entriesLimitSort="descending"
                initialMetric="totalCost"
                metrics={{
                    totalCost: {
                        label: "Total cost",
                        short: "Total revenue",
                        format: { left: "currency" },
                        important: true,
                    },
                    count: {
                        label: "Count",
                        short: "Number sold",
                        format: {},
                        important: true,
                    },
                }}
            />
        </>
    );
};

export default ExtrasScreen;
